import $http from '../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Método para listar los roles registrados.
 *
 * @param {*} {state, commit}
 * @export
 */
export async function getRoles({state, commit}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('acl-roles', {params: state.filterRoles})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setRoles', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
}

/**
 * Método para registrar un rol.
 *
 * @export
 * @param {*} { sate, commit } contiene la información del formulario.
 */
export async function saveRol({ state, commit }) {
    commit('dashboard/load', true, {root: true});
    await $http.post('acl-roles', state.selectedRol)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('resetSelectedRol');
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
        .catch((error) => {
            const codes = Object.keys(error.errors);
            let errors = [];    
        
            codes.forEach((item) => {
                error.errors[item].forEach((error) => {
                    errors.push(error);
                })
            })

            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br/>' + errors,
                showConfirmButton: false,
                timer: 2000
            })
        })
}

/**
 * Método para actualizar la información de un rol.
 *
 * @export
 * @param {*} { state, commit }
 */
export async function updateRol({ state, commit }, id) {
    commit('dashboard/load', true, {root: true});
    await $http.put(`acl-roles/${id}`, state.selectedRol)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
        .catch((error) => {
            const codes = Object.keys(error.errors);
            let errors = [];    
        
            codes.forEach((item) => {
                error.errors[item].forEach((error) => {
                    errors.push(error);
                })
            })

            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br/>' + errors,
                showConfirmButton: false,
                timer: 2000
            })
        })
}

/**
 * Método para obtener la información del rol seleccionado.
 *
 * @export
 * @param {*} { state, commit }
 * @param {BigInteger} id
 */
export async function getSelectedRol({ state, commit }, id) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`acl-roles/${id}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setSelectedRol', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
}

/**
 * Método para obtener los permisos del rol seleccionado.
 *
 * @export
 * @param {*} { state, commit }
 * @param {BigInteger} id
 */
export async function getRolPermissions({ state, commit }, id) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`acl-permissions/rol/${id}`, {params: state.filtersPermissions})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setPermissions', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
}

/**
 * Método para obtener los permisos del usuario seleccionado.
 *
 * @export
 * @param {*} { state, commit }
 * @param {BigInteger} id
 */
 export async function getUserPermissions({ state, commit }, id) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`acl-permissions/user/${id}`, {params: state.filtersPermissions})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setPermissions', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
}

/**
 * Método para asignar permisos al rol seleccionado.
 *
 * @export
 * @param {*} { state, commit }
 * @param {*} data contiene la información del permiso o los permisos a asignar.
 */
export async function assignRolPermissions({ state, commit }, data) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`acl-permissions/rol/${state.selectedRol.id}`, data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            })
        })
}

/**
* Método para asignar permisos al usuario seleccionado.
*
* @export
* @param {*} { state, commit }
* @param {*} data contiene la información del permiso o los permisos a asignar.
*/
export async function assignUserPermissions({ state, commit }, data) {
   commit('dashboard/load', true, {root: true});
   await $http.post(`acl-permissions/user/${data.id}`, data.data)
       .then((response) => {
           commit('dashboard/load', false, {root: true});
           Swal.fire({
               position: 'center',
               icon: 'success',
               title: response.data.message,
               showConfirmButton: false,
               timer: 2000
           })
       })
       .catch((error) => {
           commit('dashboard/load', false, {root: true});
           Swal.fire({
               position: 'center',
               icon: 'error',
               title: error.message,
               showConfirmButton: false,
               timer: 2000
           })
       })
}